<!-- <div class="m-grid m-grid--hor m-grid--root m-page h-100">
  <div class="m-grid__item m-grid__item--fluid m-grid m-error-4 error-page"
    style="background-image: url(assets/images/error-page.png);">
    <div class="m-error_container">
      <h1 class="m-error_number arco-primary-text">
      
        {{notAuth.nump}}
      </h1>
      <p class="m-error_title arco-primary-text">
        
        {{notAuth.error}}
      </p>
      <p class="m-error_description black-alt-text">
        
        {{notAuth.message}}
      </p>
      <button class="btn btn-save" (click)="goBack()">Back</button>
    </div>
  </div>
</div> -->

<div class="error h-100">
  <div class="error-page" style="background-image: url(assets/images/error-page.png);">
    <div class="error_container h-100 ">
      <div class="error-text">


        <p class="arco-primary-text mb-0">
          <!-- 401 -->
          {{notAuth.nump}}
        </p>
        <p class="arco-primary-text mb-0">
          <!-- ERROR -->
          {{notAuth.error}}
        </p>
        <p class="black-alt-text fs-30">
          <!-- Not Authorized to Access page -->
          {{notAuth.message}}
        </p>
      </div>
      <button class="btn btn-save" (click)="goBack()">Back</button>
      <button class="btn btn-save" (click)="goToLandingPage()">Landing Page</button>
      <button class="btn btn-save" (click)="logout()">Logout</button>

    </div>
  </div>
</div>